import { AfterContentInit, AfterViewInit, Component } from '@angular/core';

@Component({
  selector: 'app-bridge-conditions',
  templateUrl: './bridge-conditions.component.html',
  styleUrls: ['./bridge-conditions.component.css']
})
export class BridgeConditionsComponent implements AfterContentInit {

  constructor() {

  }

  ngAfterContentInit() {

  }
}
